interface GraphArrowUpSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphArrowUpSVG = ({ color, style }: GraphArrowUpSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="51"
    height="47"
    viewBox="0 0 51 47"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46565)">
      <path
        d="M0.633789 45.907H2.81958"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M49.8145 45.907H52.0002"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M43.2568 22.9535H34.5137V45.907H43.2568V22.9535Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M17.0273 38.2558H8.28418V45.907H17.0273V38.2558Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.1421 32.7907H21.3989V45.907H30.1421V32.7907Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.6283 45.907H5.00537"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M43.2569 1.09302H32.8962L35.3662 3.60697L22.4809 16.5046L15.7049 9.73883L1.54102 23.9153L6.44812 28.8558L15.0929 20.2209L21.8689 26.9977L40.4809 8.5693L43.2569 11.1598V1.09302Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46565">
        <rect width="52" height="47" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphArrowUpSVG;
